export default "__VITE_ASSET__b51d8c9c__"